import { Sparkles, PenTool, Eraser, FileImage } from "lucide-react";

export const TOOLS = {
  ampliar: {
    key: "upscale", slug: "ampliar", icon: Sparkles, color: "#00A3E0", tag: "C", accept: "image/*",
    formats: ["png", "jpg", "tiff", "pdf", "webp", "bmp"], defaultFormat: "tiff", color_modes: true, dpis: [150, 300, 600],
  },
  vetorizar: {
    key: "vectorize", slug: "vetorizar", icon: PenTool, color: "#E40046", tag: "M", accept: "image/*",
    formats: ["svg", "pdf", "eps", "ai", "png"], defaultFormat: "pdf", color_modes: false, dpis: null,
  },
  "remover-fundo": {
    key: "remove_bg", slug: "remover-fundo", icon: Eraser, color: "#FFB800", tag: "Y", accept: "image/*",
    formats: ["png", "tiff", "webp", "jpg"], defaultFormat: "png", color_modes: false, dpis: [150, 300, 600],
  },
  "pdf-imagem": {
    key: "pdf", slug: "pdf-imagem", icon: FileImage, color: "#0F172A", tag: "K", accept: "application/pdf",
    formats: ["jpg", "png", "bmp", "tiff"], defaultFormat: "jpg", color_modes: true, dpis: [150, 300, 600],
  },
};

export const TOOL_LIST = Object.values(TOOLS);
export const toolByKey = (key) => TOOL_LIST.find((t) => t.key === key);

export const CMYK_FORMATS = ["jpg", "tiff", "pdf"];

export const FORMAT_LABEL = {
  png: "PNG", jpg: "JPG", tiff: "TIFF", pdf: "PDF", webp: "WEBP", bmp: "BMP", svg: "SVG", eps: "EPS", ai: "AI",
};
